import React, { Fragment, useEffect } from 'react';
import { Button, Col, Form, message, notification, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import CustomerInformation from './components/CustomerInformation';
import ProductInformation from './components/ProductInformation';
import * as CommonService from '../../../services/CommonService';
import { INVOICE_ENDPOINT, BRANCH_ENDPOINT } from '../../../services/endpoint';
import './style.scss';

const Orders = (props) => {

	const history = useHistory();

	const [customer, setCustomer] = React.useState(null);
	const [ds, setDs] = React.useState([]);
	const [userList, setUserList] = React.useState([]);
	const [branchList, setBranchList] = React.useState([]);

	useEffect(() => {
		const init = async () => {
			try {
				window.setLoading(true);
				const [branchResp, userResp] = await Promise.all([CommonService.get(BRANCH_ENDPOINT), CommonService.get('/user/getUsers')]);
				if (branchResp.status === 200) {
					setBranchList(branchResp.data || []);
				}
				if (userResp.status === 200) {
					setUserList(userResp.data || []);
				}
			} catch (error) {
				message.error(error?.data?.message);
			} finally {
				window.setLoading(false);
			}
		};
		init();
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				const errorMsg = validate();
				if (errorMsg) {
					notification.error({ title: 'Lỗi', message: errorMsg, duration: 3 });
					return;
				}
				const body = {
					...values,
					customerId: customer.id,
					deliveryAddress: customer.addressText,
					items: ds.filter(el => el.countProduct > 0).map(el => ({
						productId: el.id,
						quantity: el.countProduct,
						unitPrice: el.retailPrice,
						discount: el.discount || 0,
						imeis: el.imeiListSelected
					}))
				};
				window.setLoading(true);
				CommonService.create(INVOICE_ENDPOINT, body).then(res => {
					message.success('Tạo đơn hàng thành công');
					history.push('/orders/' + res.data?.id);
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => window.setLoading(false));
			}
		});
	};

	const validate = () => {
		if (!customer) {
			return 'Vui lòng chọn khách hàng';
		} else if (ds.reduce((sum, item) => sum + (item?.countProduct || 0), 0) === 0) {
			return 'Số lượng không thể = 0';
		}
	};

	return (
		<Fragment>
			<Form layout={'vertical'} id={'orders-create-page'}>
				<Row>
					<Col>
						<CustomerInformation form={props.form}
																 customer={customer}
																 setCustomer={setCustomer}
																 userList={userList}
																 branchList={branchList}
						/>
					</Col>
					<Col>
						<ProductInformation form={props.form}
																ds={ds}
																setDs={setDs}
						/>
					</Col>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} onClick={() => history.push('/purchase-order')}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Tạo đơn hàng</Button>
				</Col>
			</Form>
		</Fragment>
	);
};
export default Form.create({ name: 'Orders' })(Orders);
